import { render, staticRenderFns } from "./m_my_gift.vue?vue&type=template&id=df23e8a6&scoped=true&"
import script from "./m_my_gift.vue?vue&type=script&lang=js&"
export * from "./m_my_gift.vue?vue&type=script&lang=js&"
import style0 from "./m_my_gift.vue?vue&type=style&index=0&id=df23e8a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df23e8a6",
  null
  
)

export default component.exports